import * as actionTypes from '../actions/actionTypes';
import {updateObject} from "../../utils/functions/common";

const initialState = {
    show: true
};

const showSpinnerModal = (state: any, action: any) => {
    return updateObject(state, {show: true});
};

const hideSpinnerModal = (state: any, action: any) => {
    return updateObject(state, {show: false});
};

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case actionTypes.SPINNER_MODAL_SHOW:
            return showSpinnerModal(state, action);
        case actionTypes.SPINNER_MODAL_HIDE:
            return hideSpinnerModal(state, action);
        default:
            return state;
    }
};

export default reducer;
